module.exports = __webpack_public_path__ + "media/images/megamenu_about2x-9cde6bea1e9406bf32ff5c1ae8745ae8.png";